import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PricePoint {
  t: number; // ms
  price: number;
}

/** Fetch the full price history for a set of print IDs. */
export function usePrintHistory(printIds: string[]) {
  const key = [...printIds].sort().join(',');
  return useQuery({
    queryKey: ['print-history', key],
    enabled: printIds.length > 0,
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('price_history')
        .select('print_id, price_usd, recorded_at')
        .in('print_id', printIds)
        .order('recorded_at', { ascending: true });
      if (error) throw error;
      const byPrint = new Map<string, PricePoint[]>();
      for (const row of data || []) {
        const arr = byPrint.get(row.print_id) || [];
        arr.push({ t: new Date(row.recorded_at).getTime(), price: Number(row.price_usd) });
        byPrint.set(row.print_id, arr);
      }
      return byPrint;
    },
  });
}
